import React from 'react'
import { useSurveyStore } from '../../surveyutilities/surveyStore'
import {
  Box,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Grid,
  InputAdornment
} from '@mui/material';
import {
  CalendarToday as CalendarIcon,
  Link as LinkIcon,
  Code as CodeIcon,
  AspectRatio as AspectRatioIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import IconPickerField from './IconPickerField';
function SurveySettings() {
  const { survey, setSurveySetting } = useSurveyStore();
  
 const handleInputChange = (field) => (event) => {
  setSurveySetting(field, event.target.value);
};
 const handleIconChange = (icon) =>{
  setSurveySetting("icon", icon);
 }
  const handleSwitchChange = (field) => (event) => {
    setSurveySetting(field, event.target.checked);
  };

  const handleSelectChange = (field) => (event) => {
    setSurveySetting(field, event.target.value);
  };
 // Handle date changes
  const handleDateChange = (field) => (event) => {
    const value = event.target.value;
    const dateValue = value ? new Date(value).toISOString() : null;
    setSurveySetting(field, dateValue);
  };
  // Handle number changes
  const handleNumberChange = (field) => (event) => {
    const value = event.target.value;
    setSurveySetting(field, value ? parseInt(value) : null);
  };

  // Check if the field should be visible
  const isVisible = (field) => {
    return true;
  };

  // Format date for datetime-local input
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  };


    return(
        <>
        <Box>
      
        <Box >
          <Grid container spacing={2}>
            {/* Name Field */}
            <Grid size={{ xs: 12 }}>
              <TextField
                size="small"
                fullWidth
                required
                label="Survey Name"
                value={survey.title || ''}
                onChange={handleInputChange("title")}
                helperText="Enter a descriptive name for your survey"
              />
            </Grid>

            {/* Description Field */}
            <Grid size={{ xs: 12 }}>
              <TextField
                size="small"
                fullWidth
                required
                multiline
                rows={2}
                label="Description"
                value={survey.description || ''}
                onChange={handleInputChange("description")}
               
                helperText="Provide a detailed description of your survey"
              />
            </Grid>

            {/* Category Field */}
              {isVisible('category') && (
            <Grid size={{ xs: 12 }}>
              <TextField
                size="small"
                fullWidth
                required
                label="Category"
                value={survey.category || ""}
                onChange={handleInputChange("category")}
                helperText="Enter the category for your survey"
              />
            </Grid>
              )}

            {/* Progress Settings */}
             
              <Grid size={{xs:12}} sx={{paddingLeft:1}}>
                <FormControlLabel
                  
                  control={
                    <Switch
                      size='small'
                      checked={survey.showProgressbar || false}
                      onChange={handleSwitchChange('showProgressbar')}
                    />
                  }
                  label="Show Progress Bar"
                />
              </Grid>
               {survey.showProgressbar && (
                    <Grid size={{xs:12}}>
                      <FormControl fullWidth  >
                        <InputLabel>Progress Bar Type</InputLabel>
                        <Select
                        size='small'
                          value={survey.progressbarType || 'PERCENT'}
                          label="Progress Bar Type"
                          onChange={handleSelectChange('progressbarType')}
                          
                        >
                          <MenuItem value="PERCENT">Percentage</MenuItem>
                          <MenuItem value="STEPS">Number of Questions</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                <Grid size={{xs:12}} sx={{paddingLeft:1,mb:1}}>
                    <FormControlLabel
                      control={
                        <Switch
                          size='small'
                          checked={survey.singleQuestionPerPage}
                          onChange={handleSwitchChange('singleQuestionPerPage')}
                        />
                      }
                      label="Single Question Per Page"
                    />
                  </Grid>

                   {/* Date Settings (Only for Clinic Survey) */}
                {isVisible('startDate') && (
                  <>
                    <Grid size={{xs:12}} sx={{mb:1}}>
                      <TextField
                        fullWidth
                        label="Start Date"
                        type="datetime-local"
                        value={formatDateForInput(survey.startDate)  || ''}
                        onChange={handleDateChange('startDate')}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid size={{xs:12}}>
                      <TextField
                        fullWidth
                        label="End Date"
                        type="datetime-local"
                        value={formatDateForInput(survey.endDate)  || ''}
                        onChange={handleDateChange('endDate')}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                      <Grid size={{xs:12}}>
                          <TextField
                              fullWidth
                              multiline
                              rows={3}
                              label="Survey End Message"
                              value={survey.surveyEndMessage  || ''}
                              onChange={handleInputChange('surveyEndMessage')}
                              variant="outlined"
                          />
                      </Grid>
                    <Grid size={{xs:12}}>
                        <IconPickerField
                         value={survey.icon || ''}
                         onChange={handleIconChange}
                          label="Choose Survey Icon"
                          />
                    </Grid>
                    <Grid size={{xs:12}}>
                      <FormControl fullWidth  >
                        <InputLabel>Icon Color</InputLabel>
                        <Select
                        size='small'
                          value={survey.iconColor || 'primary'}
                          label="Icon Color"
                          onChange={handleSelectChange('iconColor')}
                          
                        >
                          <MenuItem value="primary">Primary</MenuItem>
                          <MenuItem value="secondary">Secondary</MenuItem>
                           <MenuItem value="success">Success</MenuItem>
                           <MenuItem value="warning">Warning</MenuItem>
                            <MenuItem value="info">Info</MenuItem>
                             <MenuItem value="danger">Danger</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}
                {/* Completion Settings */}
                  <Grid size={{xs:12}}>
                    <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                      Completion Settings
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                  </Grid>
                
                <Grid size={{xs:12}}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Completion Message"
                        value={survey.messageAfterComplete  || ''}
                        onChange={handleInputChange('messageAfterComplete')}
                        variant="outlined"
                      />
                    </Grid>

                     <Grid size={{xs:12}}>
                      <TextField
                        fullWidth
                        label="Redirect Time (seconds)"
                        type="number"
                        value={survey.redirectTimeAfterMessage || 0}
                        onChange={handleNumberChange('redirectTimeAfterMessage')}
                        variant="outlined"
                      />
                    </Grid>

                    {isVisible('redirectUrl') && (
                      <Grid size={{xs:12}}>
                        <TextField
                          fullWidth
                          label="Redirect URL"
                          value={survey.redirectUrl  || ''}
                          onChange={handleInputChange('redirectUrl')}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LinkIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    )}
                   {/* Advanced Settings */}
                       <Grid size={{xs:12}}>
                        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                          Advanced Settings
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                      </Grid>

                          <Grid size={{ xs: 12 }}>
                              <TextField
                                  fullWidth
                                  size="small"
                                  label="Page Width"
                                  value={survey.pageWidth || '900px'}
                                  onChange={handleInputChange('pageWidth')}
                                  variant="outlined"
                                  InputProps={{
                                      startAdornment: (
                                          <InputAdornment position="start">
                                              <AspectRatioIcon />
                                          </InputAdornment>
                                      ),
                                  }}
                                  helperText="e.g., 900px, 100%, 1200px"
                              />
                          </Grid>
                          <Grid size={{ xs: 12 }} >
                              <FormControl fullWidth>
                                  <InputLabel>Header Position</InputLabel>
                                  <Select
                                      size='small'
                                      value={survey.headerPosition || "center"}
                                      label="Header Position"
                                      onChange={handleSelectChange('headerPosition')}
                                  >
                                      <MenuItem value="left">Left</MenuItem>
                                      <MenuItem value="center">Center</MenuItem>
                                      <MenuItem value="end">Right</MenuItem>
                                  </Select>
                              </FormControl>
                          </Grid>

                          <Grid size={{ xs: 12 }} >
                              <FormControl fullWidth>
                                  <InputLabel>Heading Type</InputLabel>
                                  <Select
                                      size='small'
                                      value={survey.headingType || "h1"}
                                      label="Heading Type"
                                      onChange={handleSelectChange('headingType')}
                                  >
                                      <MenuItem value="h1">H1</MenuItem>
                                      <MenuItem value="h2">H2</MenuItem>
                                      <MenuItem value="h3">H3</MenuItem>
                                      <MenuItem value="h4">H4</MenuItem>
                                  </Select>
                              </FormControl>
                          </Grid>
                          <Grid size={{ xs: 12 }} sm={6}>
                              <FormControl fullWidth>
                                  <InputLabel>Description Position</InputLabel>
                                  <Select
                                      size='small'
                                      value={survey.descriptionPosition || "center"}
                                      label="Description Position"
                                      onChange={handleSelectChange('descriptionPosition')}
                                  >
                                      <MenuItem value="left">Left</MenuItem>
                                      <MenuItem value="center">Center</MenuItem>
                                      <MenuItem value="end">Right</MenuItem>
                                  </Select>
                              </FormControl>
                          </Grid>
              {/* Padding Settings */}

              <Grid size={{ xs: 12 }} sm={4}>
                  <TextField
                      size="small"
                      fullWidth
                      label="Form Padding"
                      value={survey.pagePaddingDesktop || '2rem'}
                      onChange={handleInputChange('pagePaddingDesktop')}
                      variant="outlined"
                      InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                  <DashboardIcon />
                              </InputAdornment>
                          ),
                      }}
                      helperText="Desktop"
                  />
              </Grid>

              {/* Form Container Settings */}

              <Grid size={{ xs: 12 }}>
                  <FormControlLabel

                      control={
                          <Switch
                              size="small"
                              checked={survey.formContainerShowCard || false}
                              onChange={handleSwitchChange('formContainerShowCard')}
                          />
                      }
                      label="Show Form as Card"
                  />
              </Grid>

              <Grid size={{ xs: 12 }} sm={6}>
                  <FormControlLabel
                      control={
                          <Switch
                              size="small"
                              checked={survey.formContainerCardShadow || false}
                              onChange={handleSwitchChange('formContainerCardShadow')}
                          />
                      }
                      label="Card Shadow"
                  />
              </Grid>

              <Grid size={{ xs: 12 }} sm={6}>
                  <TextField
                      fullWidth
                      size="small"
                      label="Form Container Padding"
                      value={survey.formContainerPadding || '2rem'}
                      onChange={handleInputChange('formContainerPadding')}
                      variant="outlined"
                      helperText="Container padding"
                  />
              </Grid>

              <Grid size={{ xs: 12 }} sm={6}>
                  <TextField
                      fullWidth
                      size="small"
                      label="Border Radius"
                      value={survey.formContainerBorderRadius || 'auto'}
                      onChange={handleInputChange('formContainerBorderRadius')}
                      variant="outlined"
                      helperText="e.g., 8px, 12px, auto"
                  />
              </Grid>

              <Grid size={{ xs: 12 }} sm={6}>
                  <TextField
                      fullWidth
                      size='small'
                      label="Background Color"
                      value={survey.formContainerBackgroundColor || 'auto'}
                      onChange={handleInputChange('formContainerBackgroundColor')}
                      variant="outlined"
                      helperText="CSS color or 'auto'"
                  />
              </Grid>

              <Grid size={{ xs: 12 }} sm={6}>
                  <TextField
                      fullWidth
                      size="small"
                      label="Description Color"
                      value={survey.descriptionColor || ''}
                      onChange={handleInputChange('descriptionColor')}
                      variant="outlined"
                      helperText="CSS color value"
                  />
              </Grid>

                       <Grid size={{xs:12}}>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          label="Custom CSS"
                          value={survey.customCss  || ''}
                          onChange={handleInputChange('customCss')}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CodeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                        <Grid size={{xs:12}}>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Additional Settings (JSON)"
                            value={survey.additionalSettings  || ''}
                            onChange={handleInputChange('additionalSettings')}
                            variant="outlined"
                          />
                        </Grid>

          </Grid>
        </Box>
     
    </Box>
        </>
    )
}

export default SurveySettings